// Angular
import { Injectable } from '@angular/core';
// RxJS
import { Subject } from 'rxjs';
// Object path
import * as objectPath from 'object-path';
// Services
import { MenuConfigService } from './menu-config.service';

import { Cache } from 'aws-amplify';

@Injectable()
export class MachineService {
	// Public properties
	selectedMachine$: Subject<any> = new Subject<any>();
	mlFilter: any;

	setMachine(machine: any) {
		this.selectedMachine$.next(machine);
	}

	setMacListFilters(filters: any) {
		Cache.setItem('mlFilter', filters, {priority: 5});
	}

	getMacListFilters(): any {
		return Cache.getItem('mlFilter');
	}

	clearMacListFilters() {
		Cache.removeItem('mlFilter');
	}
}
